import { ConfigProvider, Spin } from 'antd';

import { TableWrapper } from '../../../../../components/index';
import { CargoSuppressionReportItemType } from '../../../../../services/cargoSuppressionApi';
import { TablePageProps } from '../../Reports';
import { ReportsTable } from '../../styles';
import { columns, rowKeyFor, SelectionKey } from './columns';

type SuppressionTableProps = {
  onSelectItem: (
    checked: boolean,
    record: CargoSuppressionReportItemType
  ) => void;
  selected: SelectionKey[];
  checkedAll: boolean;
  onCheckedAll: (value: boolean) => void;
};

export function SuppressionTable(
  props: TablePageProps & SuppressionTableProps
) {
  const {
    dataSource,
    scrollOptions,
    total,
    itemsPerPage,
    onChangePagination,
    isLoading,
    showSizeChanger,
    queryPage,
    onSelectItem,
    selected,
    checkedAll,
    onCheckedAll,
  } = props;

  function customizeRenderEmpty() {
    return <>Não há dados cadastrados.</>;
  }

  return (
    <Spin spinning={isLoading} tip="Carregando...">
      <TableWrapper>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <ReportsTable
            rowKey={(record: any) =>
              rowKeyFor(record as CargoSuppressionReportItemType)
            }
            pagination={{
              position: ['bottomCenter'],
              defaultPageSize: itemsPerPage || 60,
              pageSize: 60,
              total,
              onChange: onChangePagination,
              showSizeChanger,
              current: queryPage,
            }}
            columns={columns(selected, onSelectItem, checkedAll, onCheckedAll)}
            dataSource={dataSource}
            scroll={
              scrollOptions || { y: '60vh', scrollToFirstRowOnChange: false }
            }
          />
        </ConfigProvider>
      </TableWrapper>
    </Spin>
  );
}
